import { render } from "./AddNpiDialog.vue?vue&type=template&id=4332afc2&scoped=true"
import script from "./AddNpiDialog.vue?vue&type=script&lang=js"
export * from "./AddNpiDialog.vue?vue&type=script&lang=js"

import "./dialogStyles.css?vue&type=style&index=0&id=4332afc2&scoped=true&lang=css"
import "./AddNpiDialog.vue?vue&type=style&index=1&id=4332afc2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4332afc2"]])

export default __exports__